import { ACTION_PANEL_STATE_KEY } from "../../selectors";
import RootState from "~/types/store";

export const REC_MODULE_STATE_KEY = "REC_MODULE_STATE";

export const getModuleState = (state) => state[ACTION_PANEL_STATE_KEY][REC_MODULE_STATE_KEY];

export const getActivePage = (state) => getModuleState(state).activePage;

export const getTriggeredPage = (state) => getModuleState(state).triggeredPage;

export const getSendRecToLoading = (state: RootState): boolean =>
    getModuleState(state).sendToRecLoading;
